import React from 'react'
import Layout from '../../components/Layout'

export default () => (
  <Layout>
    <section className="section">
      <div className="container">
        <div className="content">
          <h1>¡Gracias por Contactarnos!</h1>
          <p>Nuestro equipo se pondrá en contacto con usted lo antes posible.</p>
        </div>
      </div>
    </section>
  </Layout>
)
